"use client";
import useMediaQuery from "@/utils/hooks/useMediaQuery";
import { StoreLocator } from "../../StoreLocator";

export default function StoreLocatorDesktopWrapper(storeLocatorData: any) {
  const mobileMedia: number = useMediaQuery() || 0;
  return mobileMedia && mobileMedia >= 1024 ? (
    <div className="store-locator hidden lg:flex">
      <StoreLocator storeLocatorData={storeLocatorData} />
    </div>
  ) : (
    <></>
  );
}
